import React, { useState, useEffect } from "react";
import Productslider from "components/Sections/productslider/productslider";
import { Product } from "components/Sections/productlist/productcard";
import ProductList from "components/Sections/productlist/productcard";
import productsData from "components/Sections/productlist/productlist.json";

import "./productpage.css";

const Productpage = () => {
  const imageUrls = [
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/o5rgXJma6tyNOpIl.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/DLjnCSIZafhQm8g0.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/cA17YmlgQ3oxJByg.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/hVg1xHXMfybnkYrz.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/Q6eo7MrmZImAofog.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/o5rgXJma6tyNOpIl.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/DLjnCSIZafhQm8g0.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/cA17YmlgQ3oxJByg.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/hVg1xHXMfybnkYrz.png?x-amz-process=image/format,webp/quality,Q_80",
    "https://image01-in.oneplus.net/india-oneplus-statics-file/epb/202310/17/Q6eo7MrmZImAofog.png?x-amz-process=image/format,webp/quality,Q_80",
  ];

  const [latestProducts, setLatestProducts] = useState<Product[]>([]);

  useEffect(() => {
    // Sort the data by ID in descending order to get the latest products first
    const sortedData = productsData.sort((a, b) => b.id - a.id);
    // Take the first 4 items
    const latestFourProducts = sortedData.slice(0, 4);
    setLatestProducts(latestFourProducts);
  }, []); // Empty dependency array to run the effect only once

  const ImageGallery: React.FC = () => {
    return (
      <div className="image-gallery">
        {imageUrls.map((imageUrl, index) => (
          <img key={index} src={imageUrl} alt={`Image ${index + 1}`} />
        ))}
      </div>
    );
  };

  return (
    <div className="nc-PageHomeDemo6 relative  background-white">
      <div className="container">
        <div className="product-gallry-discription">
          <div className="product-gallery">
            <Productslider
              data={imageUrls}
              renderItem={(url, index) => (
                <img
                  src={url}
                  alt={`Image ${index + 1}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )}
            />
          </div>

          <div className="product-short-discription">
            <div className="seller-details">
              <h4 className="montserrat">Seller Details : </h4>
              <div className="seller-image-detail">
                <img src="https://www.oneplus.com/content/dam/oasis/page/common/logo/OnePlus_Logo.png" />
                <h6 className="seler-name montserrat">Onelplus</h6>
              </div>
              <span className="seller-verified">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                >
                  <path
                    d="M7.6 21L5.7 17.8L2.1 17L2.45 13.3L0 10.5L2.45 7.7L2.1 4L5.7 3.2L7.6 0L11 1.45L14.4 0L16.3 3.2L19.9 4L19.55 7.7L22 10.5L19.55 13.3L19.9 17L16.3 17.8L14.4 21L11 19.55L7.6 21ZM9.95 14.05L15.6 8.4L14.2 6.95L9.95 11.2L7.8 9.1L6.4 10.5L9.95 14.05Z"
                    fill="#00A0C0"
                  />
                </svg>
              </span>
            </div>

            <div className="product-names">
              <h2 className="product-name montserrat">
                Steel Modular Operation Theatre
              </h2>
            </div>

            <div className="product-descs">
              <h2 className="product-name-desc montserrat">
                {" "}
                Know Us Loyalty, responsibility and quality are the founding
                pillars of JK Health Group. Keeping these values at the core of
                our work
              </h2>
            </div>

            <div className="brand-details">
              <h4 className="montserrat">Brand : </h4>
              <div className="brand-image-detail">
                <img src="https://www.oneplus.com/content/dam/oasis/page/common/logo/OnePlus_Logo.png" />
                <h6 className="brand-name montserrat">Onelplus</h6>
              </div>
              <span className="brand-verified">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                >
                  <path
                    d="M7.6 21L5.7 17.8L2.1 17L2.45 13.3L0 10.5L2.45 7.7L2.1 4L5.7 3.2L7.6 0L11 1.45L14.4 0L16.3 3.2L19.9 4L19.55 7.7L22 10.5L19.55 13.3L19.9 17L16.3 17.8L14.4 21L11 19.55L7.6 21ZM9.95 14.05L15.6 8.4L14.2 6.95L9.95 11.2L7.8 9.1L6.4 10.5L9.95 14.05Z"
                    fill="#00A0C0"
                  />
                </svg>
              </span>
            </div>

            <div className="product-price">
              <div className="pricing">
                <p className="price montserrat">
                  <span className="currncy montserrat">₹</span>15000.00{" "}
                  <span className="price-per-status"></span>
                </p>
                <h3 className="">
                  <span className="minimun-text montserrat">
                    Minimum order quantity -{" "}
                  </span>
                  <span className="minimum-value montserrat"></span>5{" "}
                  <span className="pircr-or-pirces">Piece-Pieces</span>
                </h3>
              </div>
            </div>

            <div className="location-selertype">
              <div className="seler-location">
                <span className="svg-location">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="19"
                    viewBox="0 0 12 19"
                    fill="none"
                  >
                    <path
                      d="M5.51851 9.16413C4.9958 9.16413 4.49449 8.93572 4.12488 8.52914C3.75526 8.12256 3.54761 7.57113 3.54761 6.99614C3.54761 6.42116 3.75526 5.86972 4.12488 5.46314C4.49449 5.05657 4.9958 4.82816 5.51851 4.82816C6.04122 4.82816 6.54253 5.05657 6.91214 5.46314C7.28176 5.86972 7.48941 6.42116 7.48941 6.99614C7.48941 7.28085 7.43843 7.56276 7.33938 7.82579C7.24033 8.08883 7.09516 8.32782 6.91214 8.52914C6.72913 8.73046 6.51186 8.89015 6.27274 8.9991C6.03362 9.10805 5.77733 9.16413 5.51851 9.16413ZM5.51851 0.925781C4.05491 0.925781 2.65126 1.56534 1.61633 2.70375C0.581413 3.84216 0 5.38618 0 6.99614C0 11.5489 5.51851 18.2697 5.51851 18.2697C5.51851 18.2697 11.037 11.5489 11.037 6.99614C11.037 5.38618 10.4556 3.84216 9.42068 2.70375C8.38576 1.56534 6.98211 0.925781 5.51851 0.925781Z"
                      fill="#1188A8"
                    />
                  </svg>
                </span>
                <span className="text-location">New Delhi, Delhi</span>

                <span className="buttun-seler-type montserrat">
                  Victor Imports
                </span>
              </div>
            </div>

            <div className="product-single-button">
              <a className="send-enquiry-btn montserrat" href="">
                SEND INQUIRY
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M19.3174 1L13.0177 18.999L9.41791 10.8994L1.31836 7.29965L19.3174 1Z"
                    stroke="white"
                    stroke-width="1.89463"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.3174 1L9.41797 10.8994"
                    stroke="white"
                    stroke-width="1.89463"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <a className="send-enquiry-btn get-enquiry montserrat" href="">
                GET NUMBER
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="21"
                  viewBox="0 0 17 21"
                  fill="none"
                >
                  <path
                    d="M7.72368 3.18859C7.57155 2.77444 7.26672 2.43419 6.87171 2.23764C6.47669 2.04109 6.02144 2.00313 5.59934 2.13156C3.59839 2.74851 2.19999 4.46566 2.50023 6.45222C2.83602 8.65704 3.58315 10.7791 4.70272 12.708C5.81031 14.6325 7.26233 16.3368 8.98635 17.7361C10.5369 18.9905 12.7127 18.6451 14.2468 17.2055C14.5695 16.9026 14.7653 16.4886 14.7947 16.047C14.8241 15.6055 14.6849 15.1692 14.4052 14.8262L13.307 13.4833C13.0871 13.2133 12.791 13.0156 12.4573 12.9158C12.1236 12.8161 11.7677 12.8189 11.4356 12.9239L8.90204 13.726L8.4599 13.2694C7.90281 12.6917 7.41551 12.0504 7.00802 11.359C6.61253 10.6597 6.30449 9.91446 6.09084 9.14003L5.92015 8.53337L7.8738 6.73395C8.13159 6.49458 8.31244 6.184 8.39336 5.84164C8.47428 5.49929 8.45163 5.14061 8.32828 4.81115L7.72573 3.19065L7.72368 3.18859ZM4.99474 0.165574C5.91841 -0.117032 6.91519 -0.0356951 7.78082 0.392918C8.64646 0.82153 9.31541 1.56496 9.65059 2.47088L10.2531 4.09138C10.5189 4.80332 10.567 5.57823 10.3912 6.31757C10.2155 7.0569 9.8238 7.72726 9.26603 8.24341L8.25836 9.17088C8.38792 9.5287 8.56272 9.93794 8.78893 10.3348C9.01514 10.7256 9.27837 11.0813 9.51898 11.3713L10.8146 10.96C11.5389 10.7313 12.3152 10.7253 13.0429 10.9427C13.7707 11.1601 14.4165 11.591 14.8967 12.1795L15.9948 13.5224C16.6051 14.2687 16.9093 15.2189 16.846 16.1808C16.7826 17.1428 16.3564 18.0449 15.6534 18.7047C13.6093 20.6234 10.2716 21.4192 7.69489 19.334C5.77484 17.7763 4.15761 15.8789 2.92387 13.7362C1.67487 11.5848 0.84124 9.21791 0.466379 6.75863C-0.0271747 3.48267 2.32338 0.988164 4.99474 0.16763V0.165574Z"
                    fill="#111827"
                  />
                </svg>
              </a>
            </div>

            <div className="product-single-badges">
              <div className="bagess cashes-abadges">
                <span className="bageses-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="37"
                    height="36"
                    viewBox="0 0 37 36"
                    fill="none"
                  >
                    <path
                      d="M36.2155 9.9029C36.5597 9.68387 36.7709 9.30839 36.7709 8.8938C36.7709 8.48703 36.5519 8.10373 36.1999 7.90035L24.4662 0.860126C24.0907 0.633274 23.6213 0.641097 23.2459 0.867948L0.560708 14.9484C0.216519 15.1674 0.00531281 15.5429 0.00531281 15.9575C0.00531281 16.3643 0.224342 16.7476 0.576353 16.9588L12.3101 23.999C12.4978 24.1085 12.7012 24.1633 12.9124 24.1633C13.1236 24.1633 13.3426 24.1007 13.5304 23.9833L19.5615 20.2364V21.3863L12.9046 25.5244L1.78101 18.8518C1.22562 18.5154 0.505951 18.6954 0.169585 19.2507C-0.166781 19.8061 0.0131353 20.5258 0.568531 20.8622L12.3022 27.9024C12.49 28.0119 12.6934 28.0667 12.9046 28.0667C13.1158 28.0667 13.3348 28.0041 13.5225 27.8867L19.5537 24.1398V25.2897L12.8967 29.4278L1.78101 22.763C1.22562 22.4267 0.505951 22.6066 0.169585 23.162C-0.166781 23.7174 0.0131353 24.437 0.568531 24.7734L12.3022 31.8136C12.49 31.9231 12.6934 31.9779 12.9046 31.9779C13.1158 31.9779 13.3348 31.9153 13.5225 31.798L19.5537 28.051V29.2009L12.8967 33.3312L1.78101 26.6743C1.22562 26.3379 0.505951 26.5178 0.169585 27.0732C-0.166781 27.6286 0.0131353 28.3483 0.568531 28.6846L12.3022 35.7249C12.49 35.8344 12.6934 35.8891 12.9046 35.8891C13.1158 35.8891 13.3348 35.8266 13.5225 35.7092L28.4165 26.4631C28.4165 26.4631 28.4243 26.4631 28.4322 26.4631L36.2155 21.6366C36.7631 21.2924 36.9352 20.5727 36.591 20.0174C36.2468 19.462 35.5271 19.2977 34.9717 19.6419L28.9406 23.381V22.2311L36.2077 17.7175C36.7553 17.3734 36.9274 16.6537 36.5832 16.0983C36.239 15.5429 35.5193 15.3786 34.9639 15.7228L28.9328 19.4698V18.3199L36.1999 13.8063C36.7474 13.4621 36.9195 12.7425 36.5754 12.1871C36.2312 11.6317 35.5115 11.4674 34.9561 11.8116L28.925 15.5585V14.4086L36.1921 9.89508L36.2155 9.9029ZM12.9046 21.6131L3.43155 15.934L9.0168 12.4687L18.4898 18.1478L12.9046 21.6131ZM26.6017 24.8438L21.9082 27.7538V18.1165C21.9082 18.1165 21.9082 18.0852 21.9082 18.0617C21.9082 17.9992 21.9004 17.9366 21.8848 17.874C21.8769 17.8349 21.8691 17.7958 21.8535 17.7645C21.8378 17.7254 21.8222 17.6784 21.8065 17.6393C21.7831 17.5924 21.7674 17.5533 21.744 17.5063C21.744 17.5063 21.7361 17.4907 21.7283 17.4907C21.6579 17.3812 21.564 17.2873 21.4623 17.2013C21.4467 17.1856 21.4311 17.17 21.4076 17.1621C21.3841 17.1465 21.3685 17.1309 21.345 17.1152L11.2697 11.0684L16.057 8.09591L26.6095 14.4243V24.836L26.6017 24.8438ZM27.7673 12.3904L18.2942 6.70351L23.8795 3.23816L33.3525 8.91727L27.7751 12.3826L27.7673 12.3904Z"
                      fill="#111827"
                    />
                  </svg>
                </span>
                <span className="bageses-text montserrat">
                  Cash
                  <b>Advance</b>
                </span>
              </div>
              <div className="bagess trusted-abadges">
                <span className="bageses-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="31"
                    height="36"
                    viewBox="0 0 31 36"
                    fill="none"
                  >
                    <path
                      d="M15.1126 0.693848L30.2252 5.98326V18.164C30.2252 24.401 26.3957 28.761 22.8261 31.4677C20.6715 33.0863 18.3075 34.4055 15.7987 35.3894C15.755 35.4063 15.7112 35.4229 15.6673 35.4393L15.6295 35.4529L15.6189 35.4559L15.6144 35.4574C15.6128 35.4574 15.6113 35.4574 15.1126 34.0323L14.6124 35.4589L14.6063 35.4559L14.5958 35.4529L14.558 35.4378C14.3561 35.3632 14.1556 35.2851 13.9565 35.2035C11.6208 34.2404 9.41692 32.9845 7.39763 31.4662C3.83105 28.7625 0 24.4025 0 18.1656V5.98326L15.1126 0.693848ZM15.1126 34.0323L14.6124 35.4589L15.1126 35.6342L15.6128 35.4589L15.1126 34.0323ZM15.1126 32.4122L15.1262 32.4062C17.2176 31.5425 19.1914 30.4178 21.0005 29.0587C24.2316 26.612 27.2027 23.0348 27.2027 18.164V8.12926L15.1126 3.89772L3.02252 8.12926V18.164C3.02252 23.0348 5.99366 26.609 9.22474 29.0602C11.0379 30.4214 13.0163 31.5487 15.1126 32.4122ZM24.289 12.6374L13.6029 23.3235L7.19058 16.9127L9.32902 14.7743L13.6014 19.0496L22.1506 10.5004L24.2875 12.6374H24.289Z"
                      fill="#111827"
                    />
                  </svg>
                </span>
                <span className="bageses-text montserrat">
                  Trusted<b>Sellers</b>
                </span>
              </div>
              <div className="bagess safe-abadges">
                <span className="bageses-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="37"
                    viewBox="0 0 35 37"
                    fill="none"
                  >
                    <path
                      d="M24.8977 31.4327C25.5456 31.4327 26.0709 30.9074 26.0709 30.2595C26.0709 29.6117 25.5456 29.0864 24.8977 29.0864C24.2498 29.0864 23.7246 29.6117 23.7246 30.2595C23.7246 30.9074 24.2498 31.4327 24.8977 31.4327Z"
                      fill="#111827"
                    />
                    <path
                      d="M19.1128 27.6934C17.908 27.6934 16.7911 27.1491 16.0509 26.2C15.3107 25.251 15.0514 24.0345 15.3447 22.866L16.404 18.6287C16.7982 17.0579 18.2024 15.9634 19.8178 15.9634H24.007L22.9653 24.2925C22.7236 26.2317 21.066 27.6946 19.1116 27.6946L19.1128 27.6934ZM19.819 18.3084C19.2805 18.3084 18.8124 18.6745 18.6799 19.1989L17.6205 23.435C17.5044 23.8996 17.6065 24.3794 17.8997 24.7548C18.193 25.1313 18.6353 25.3472 19.1128 25.3472C19.887 25.3472 20.5428 24.7677 20.639 24.0004L21.3499 18.3084H19.819Z"
                      fill="#111827"
                    />
                    <path
                      d="M25.0239 27.6934C23.7968 27.6934 22.6284 27.1667 21.8166 26.247C21.0048 25.3272 20.6247 24.1002 20.7772 22.8825L21.6418 15.9634H28.406L29.2718 22.8825C29.4243 24.1002 29.0454 25.3272 28.2324 26.247C27.4194 27.1667 26.251 27.6934 25.0239 27.6934ZM23.7135 18.3084L23.1047 23.1722C23.0343 23.7318 23.202 24.2714 23.5739 24.6926C24.3188 25.5361 25.7289 25.5361 26.4739 24.6926C26.8458 24.2714 27.0135 23.7306 26.9431 23.1722L26.3331 18.3084H23.7135Z"
                      fill="#111827"
                    />
                    <path
                      d="M30.9396 27.6936C28.9852 27.6936 27.3275 26.2307 27.0859 24.2916L26.043 15.9624H30.2334C31.8499 15.9624 33.2542 17.0593 33.646 18.6266L34.7065 22.8651C34.9998 24.0335 34.7417 25.2488 34.0003 26.1991C33.2588 27.1493 32.1432 27.6925 30.9384 27.6925L30.9396 27.6936ZM28.7013 18.3086L29.4133 24.0006C29.5095 24.7679 30.1653 25.3474 30.9396 25.3474C31.417 25.3474 31.8593 25.1315 32.1526 24.755C32.4459 24.3796 32.5479 23.8997 32.4318 23.4364L31.3713 19.1979C31.2399 18.6747 30.7718 18.3086 30.2334 18.3086H28.7013Z"
                      fill="#111827"
                    />
                    <path
                      d="M29.2516 36.1271H20.8028C19.4584 36.1271 18.175 35.5488 17.2846 34.5399C16.3942 33.531 15.9789 32.1866 16.1455 30.8504L16.8247 25.4224L19.1522 25.7133L18.4729 31.1413C18.3885 31.8182 18.5914 32.474 19.0419 32.9855C19.4947 33.4981 20.1188 33.7797 20.8016 33.7797H29.2504C29.9332 33.7797 30.5573 33.4981 31.0101 32.9855C31.4617 32.4728 31.6647 31.8182 31.5791 31.1413L30.8998 25.7133L33.2273 25.4224L33.9065 30.8504C34.0743 32.1866 33.6578 33.5298 32.7674 34.5399C31.877 35.5476 30.5936 36.1271 29.2492 36.1271H29.2516Z"
                      fill="#111827"
                    />
                    <path
                      d="M12.9059 14.9886C9.02406 14.9886 5.86719 11.8317 5.86719 7.94987C5.86719 4.068 9.02406 0.911133 12.9059 0.911133C16.7878 0.911133 19.9447 4.068 19.9447 7.94987C19.9447 11.8317 16.7878 14.9886 12.9059 14.9886ZM12.9059 3.25738C10.318 3.25738 8.21343 5.36196 8.21343 7.94987C8.21343 10.5378 10.318 12.6424 12.9059 12.6424C15.4938 12.6424 17.5984 10.5378 17.5984 7.94987C17.5984 5.36196 15.4938 3.25738 12.9059 3.25738Z"
                      fill="#111827"
                    />
                    <path
                      d="M3.49356 36.0098C1.42652 35.5863 0 33.6659 0 31.5555V25.9339C0 19.4911 4.56227 13.7533 10.9323 12.7926C14.8834 12.1966 18.7864 13.4155 21.6558 16.0656L20.0639 17.7889C17.9323 15.8192 15.0969 14.8162 12.1711 15.0168C6.573 15.3992 2.34742 20.2994 2.34742 25.9104V31.5684C2.34742 32.6031 3.05129 33.5639 4.07191 33.7328C5.37055 33.9475 6.4991 32.9456 6.4991 31.6857V26.4266C6.4991 25.779 7.02466 25.2535 7.67222 25.2535C8.31978 25.2535 8.84534 25.779 8.84534 26.4266V31.6857C8.84534 34.4273 6.33603 36.5952 3.49356 36.0122V36.0098Z"
                      fill="#111827"
                    />
                    <path
                      d="M13.4943 36.105H4.55859V33.7588H13.4943C14.1418 33.7588 14.6674 34.2843 14.6674 34.9319C14.6674 35.5795 14.1418 36.105 13.4943 36.105Z"
                      fill="#111827"
                    />
                  </svg>
                </span>
                <span className="bageses-text montserrat">
                  Safe<b>Payments</b>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="product-discription-list">
          <div className="product-specification">
            <h2 className="product-specs-title-for-product-single for-list-prod montserrat">
              Product Specification
            </h2>
            <ProductList products={latestProducts} />
          </div>

          <div className="product-specification">
            <h2 className="product-specs-title-for-product-single for-sepcs montserrat">
              Product Specification
            </h2>
            <ul className="product-specification-lists">
              <ul className="product-sepecs-list">
                <li className="specs-list-head montserrat">
                  Usage/Application
                </li>
                <li className="specs-list-content montserrat">Positioning</li>
              </ul>
              <ul className="product-sepecs-list">
                <li className="specs-list-head montserrat">
                  Usage/Application
                </li>
                <li className="specs-list-content montserrat">Positioning</li>
              </ul>
              <ul className="product-sepecs-list">
                <li className="specs-list-head montserrat">
                  Usage/Application
                </li>
                <li className="specs-list-content montserrat">Positioning</li>
              </ul>
            </ul>
          </div>

          <div className="product-discription">
            <h2 className="product-specs-title-for-product-single for-desc montserrat">
              Product Description
            </h2>
            <ul className="product-desc-list">
              <li className="specs-list-content montserrat">
                Meditech (India) is counted amidst the renowned in
                manufacturing, supplying and exporting of high quality
                health-care and surgical equipments. The company offers a
                comprehensive range of operation theater equipment, OT tables,
                universal operating tables, universal operating lights,
                orthopedic attachments, neuro attachment, hospital furniture and
                suction machines. Meditech (India) is an ISO 9001 & ISO 13485
                Certified & CE MARK Company specifically focused on offering the
                superior quality products and timely services. Each of its
                surgical accessories for the operation theaters is designed
                ergonomically and certified by competent medical authorities.
                All its products are in compliance to various Indian as well as
                international quality standards. At Meditech (India) there is a
                team of experienced professionals from this industry who possess
                years of experience. The company's entire business operations
                are inclined to achieve total customer satisfaction. At the same
                time, it also strives to offer all these reliable surgical
                products at most competitive prices
              </li>
            </ul>
          </div>

          <div className="produc-image-list">
            <h2 className="product-specs-title-for-product-single for-images montserrat">
              Product Images
            </h2>
            <ImageGallery />
          </div>

          <div className="product-details">
            <h2 className="product-specs-title-for-product-single for-detail montserrat">
              Product Details
            </h2>
            <ul className="product-detail-list">
              <li className="specs-list-detail montserrat">
                Meditech (India) is counted amidst the renowned in
                manufacturing, supplying and exporting of high quality
                health-care and surgical equipments. The company offers a
                comprehensive range of operation theater equipment, OT tables,
                universal operating tables, universal operating lights,
                orthopedic attachments, neuro attachment, hospital furniture and
                suction machines. Meditech (India) is an ISO 9001 & ISO 13485
                Certified & CE MARK Company specifically focused on offering the
                superior quality products and timely services. Each of its
                surgical accessories for the operation theaters is designed
                ergonomically and certified by competent medical authorities.
                All its products are in compliance to various Indian as well as
                international quality standards. At Meditech (India) there is a
                team of experienced professionals from this industry who possess
                years of experience. The company's entire business operations
                are inclined to achieve total customer satisfaction. At the same
                time, it also strives to offer all these reliable surgical
                products at most competitive prices
              </li>
            </ul>
          </div>

          <div className="product-specification">
            <h2 className="product-specs-title-for-product-single for-list-prod montserrat">
              Product Specification
            </h2>
            <ProductList products={latestProducts} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productpage;
